import { useState, useEffect,useRef } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
  useParams
} from "react-router-dom";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  Container,
} from "reactstrap";
import { toast } from 'react-toastify';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { userService } from "../../services/authentication";
import { usermanageService } from "../../services/usermanageService";
import { clientmanageService } from "../../services/clientmanageService.js";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import Buttoncomponent from 'components/Buttoncomponent.js';
import Select from 'react-select';

const Addfreqmaster = (props) => {
    const params  = useParams();
  const [inputFields, setInputfields] = useState({});
  const [disablestate, setdisablestate] = useState(false);
  const [freqdata, setfreqdata] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const daydata = [];
  for(let i = 1; i <= 31; i++){
    if(i<=9 && i>=1){
      daydata.push({value : '0'+i,label : '0'+i})
    }else{
      daydata.push({value : i,label : i})
    }
  }
  const monthdaydata = [{value:'01',label : 'Jan'},{value:'02',label :'Feb'},{value:'03',label :'March'},{value:'04',label :'April'},{value:'05',label :'May'},{value:'06',label :'June'},{value:'07',label :'July'},{value:'08',label :'Aug'},{value:'09',label :'Sept'},{value:'10',label :'Oct'},{value:'11',label :'Nov'},{value:'12',label :'Dec'}];
  async function inputhandler(e) {
    console.log(e);
    setSelectedClient(e); 
    setInputfields((prevInputFields) => ({
      ...prevInputFields,
      user_id: e.value,
    }));
  
    try {
      const response = await clientmanageService.getclientfreq(e.value);
  
      if (response.data.data.governance_freq != null) {
        setInputfields((prevInputFields) => ({
          ...prevInputFields,
          frequency: response.data.data.governance_freq,
        }));
        if(response.data.data.governance_freq=='Monthly'){
          setfreqdata(daydata)
          setInputfields((prevInputFields) => ({
            ...prevInputFields,
            freq_months : []
          }));
        }else{
          setfreqdata(monthdaydata)
        }
      } else {
        setInputfields((prevInputFields) => ({
          ...prevInputFields,
          frequency: '',
          freq_months : []
        }));
      }
      
      if(response.data.data.freq_months != null){
        let freq_months = response.data.data.freq_months.split(',');
        console.log(freq_months)
        setInputfields((prevInputFields) => ({
         ...prevInputFields,
         freq_months: Array.isArray(freq_months) ? freq_months.map(x => x) : [],
       }));
       }else{
         setInputfields((prevInputFields) => ({
           ...prevInputFields,
           freq_months : []
         }));
       }
       if(response.data.data.services != null){
        let services = response.data.data.services.split(',');
        setInputfields((prevInputFields) => ({
         ...prevInputFields,
         services: Array.isArray(services) ? services.map(x => x) : [],
       }));
       }else{
         setInputfields((prevInputFields) => ({
           ...prevInputFields,
           services : []
         }));
       }
       const roles = ['director', 'manager', 'other'];
       const responseData = response.data.data;

setInputfields((prevInputFields) => {
  const updatedFields = { ...prevInputFields };

  roles.forEach(role => {
    updatedFields[role] = responseData[role] ?? []; // Fallback to empty array
  });

  return updatedFields;
});
setBoxes(() => {
  const newBoxCounts = {};

  roles.forEach(role => {
    newBoxCounts[role] = responseData[role]?.length || 0;
  });

  return newBoxCounts;
});
    } catch (error) {
      // Handle any API call errors here
    }
  }
  const [disableMonth,setDisableMonth] = useState(false);
  function inputhandler1(e) {
    setDisableMonth(false)
    if(Array.isArray(e)){   
      setInputfields({...inputFields,freq_months : Array.isArray(e) ? e.map(x => x.value) : []})  

    }else{
      setInputfields({ ...inputFields, [e.target.name]: e.target.value } );
      if(e.target.name == 'frequency'){
        setfreqdata([]);
        if(e.target.value=='Monthly'){
          setInputfields((prevInputFields) => ({
            ...prevInputFields,
            freq_months:  [],
          }));
          setDisableMonth(true)
        }else{
          setfreqdata(monthdaydata)
        }
    }
  }
 }

  useEffect(() => {
    get_unique_companieslist();
    if (params.id) {
    inputhandler({ value: params.id });
  }
  }, [params.id]);



  function addclientfrequency(e){
    setdisablestate(true)
    e.preventDefault();
    clientmanageService.addclientfrequency(inputFields).then((response)=>{
      
      if(response.status == 200){
         toast.success(response.data.message); 
         if(!params.id){
          document.getElementById("adduser-form").reset();
          setInputfields({});
          setSelectedClient(null); 
         }
      }else{
        console.log(response.data);
         toast.error(response.data.message);
      }
      setdisablestate(false)
    });
  }
  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
function get_unique_companieslist(){
  clientmanageService.getuniqueclient().then((response)=>{
    setUniqueCompaniesData(response.data);
  });
}
  const styles = {
    'color':'#4a4444',
  };
  const [servicesData, setservicesData] = useState(['YearEnd','BookKeeping','PayRoll','IT','OffShore','Management Reporting','Hybrid','Admin services','TAT','Back Office','Customer Service','Finance & Accounting','Tax','SME']);
  function handleServicesTakenChange(serviceName) {
    const updatedServicesTaken = [...inputFields.services];
   
    if (updatedServicesTaken.includes(serviceName)) {
      updatedServicesTaken.splice(updatedServicesTaken.indexOf(serviceName), 1);
    } else {
      updatedServicesTaken.push(serviceName);
    }
    setInputfields({
      ...inputFields,
      services: updatedServicesTaken,
    });
  }
    
    const [boxes, setBoxes] = useState({
      director: 0,
      manager: 0,
      other: 0,
    });
    
    const addBox = (type) => {
      setBoxes((prev) => ({
        ...prev,
        [type]: prev[type] + 1,
      }));
    };
    
    const removeBox = (type) => {
      setBoxes((prev) => ({
        ...prev,
        [type]: prev[type] > 0 ? prev[type] - 1 : 0,
      }));
    };
    
    const inputclienthandler = (e, index, role) => {
      const { name, value } = e.target;
    
      setInputfields((prev) => {
        const updated = { ...prev };
        if (!updated[role]) {
          updated[role] = [];
        }
    
        updated[role][index] = {
          ...updated[role][index],
          [name]: value,
        };
    
        return updated;
      });
    };

    const [clienthistory, setclienthistory] = useState([]);
    const [showhistory, setshowhistory] = useState(false);
    function getclienthistory(selected_client){
      usermanageService.getclienthistory(selected_client).then((response) => {
          setclienthistory(response.data.client_history)
      })
    }
    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const pad = (n) => (n < 10 ? '0' + n : n);
    
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <div className="row">
          <div className="col-xl-12">
            <div className="col-md-12 col-12">
              <div class="row">
                  <div class="col-md-6"><h2>Governance Call Master Data</h2></div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-2 offset-md-10">
                        <Buttoncomponent/>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
              <Card className="card">
              <Form role="form" id="adduser-form" onSubmit={addclientfrequency}>
                <div className="row">
                <div className="col-md-4">
                  <label>Select Client</label>
                {(uniquecompanieslist.length > 0)?
                    <Select 
                   className="input-group-alternative mb-3" 
                    name="user_id"
                    options={uniquecompanieslist} // set list of the data
                    onChange={(e) => { inputhandler(e)}}
                    searchable
                    defaultValue={uniquecompanieslist.find(obj => String(obj.value) === String(params.id)) || null}
                    isClearable={false}
                  />
                        : null }
                     </div>
                    <div className="col-md-4">
                    <label>Select Frequency</label>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                          <select class="form-control" name="frequency" value={inputFields.frequency} onChange={inputhandler1} >
                              <option value=""> Select frequency</option>
                                <option value="Quarterly">Quarterly</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Annually">Annually</option>
                                <option value="HalfYearly">HalfYearly</option>
                              </select>
                          </InputGroup>
                        </FormGroup>
                    </div>
                    <div className="col-md-4">
                    {!disableMonth ?
                  <>
                    <label>Months</label>
                                <Select 
                                    className="input-group-alternative mb-3" 
                                    name="freq_months" 
                                    allowSelectAll={true} 
                                    value={(inputFields.freq_months) ? freqdata.filter(obj => inputFields.freq_months.includes(obj.value)) : ''} // set selected values
                                    options={freqdata} // set list of the data
                                    onChange={inputhandler1}
                                    isMulti
                                    isClearable
                                    // required
                                  />
                                  {inputFields.freq_months && <div style={{ marginTop: 20, lineHeight: '25px' }}></div>}
                    </> :''}
                    </div>
                </div>
                <div className="row">
                        <div className="col-md-12">
                    <FormGroup>
                      <label>Services Taken</label><br />
                     
                      {servicesData.map((service, index) => (
                        <label key={index}>
                          <input
                            type="checkbox"
                            name="services"
                            value={service}
                            //checked={ inputFields.services && inputFields.services.length > 0 ? inputFields.services.includes(service) : []}
                            checked={Array.isArray(inputFields.services) && inputFields.services.includes(service)}
                            onChange={() => handleServicesTakenChange(service)}
                          />
                          &nbsp; {service} &nbsp;
                        </label>
                      ))}
                    </FormGroup>
                  </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                           
                                            <a className="btn btn-info mb-2"  onClick={() => addBox('director')}>+ Director’s / Partner’s information  </a>
                                        <br></br>
                                                  {(() => {
                                            const arr1 = [];
                                            for (let k = 0; k < boxes.director; k++) {
                                                arr1.push(
                                                 <>
                                                    
                                                    <div className="col-md-12">
                                                       <FormGroup>
                                                       {/* <label>Level</label> */}
                                                       <div className="row">
                                                     
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="name"
                                                            type="text"
                                                            name="name"
                                                            value={inputFields.director && inputFields.director[k] ? inputFields.director[k].name : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'director')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="email"
                                                            type="text"
                                                            name="email"
                                                            value={inputFields.director && inputFields.director[k] ? inputFields.director[k].email : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'director')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                         <button
                                       type="button"
                                         className="btn btn-danger mt-2" 
                                         onClick={() => removeBox('director')}
                                       >
                                         <i className="fa fa-remove"></i>
                                       </button>
                                                         </div> 
                                                    
                                                    
                                                        </div>
                                                      </FormGroup>    
                                                    </div> 
                                                    </>
                                                );
                                            }
                                            return arr1;
                                            
                                        })()}
                                                   
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                           
                                            <a className="btn btn-info mb-2"  onClick={() => addBox('manager')}>+ Client Manager’s Name   </a>
                                        <br></br>
                                                  {(() => {
                                            const arr1 = [];
                                            for (let k = 0; k < boxes.manager; k++) {
                                                arr1.push(
                                                 <>
                                                    
                                                    <div className="col-md-12">
                                                       <FormGroup>
                                                       {/* <label>Level</label> */}
                                                       <div className="row">
                                                     
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="name"
                                                            type="text"
                                                            name="name"
                                                            value={inputFields.manager && inputFields.manager[k] ? inputFields.manager[k].name : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'manager')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="email"
                                                            type="text"
                                                            name="email"
                                                            value={inputFields.manager && inputFields.manager[k] ? inputFields.manager[k].email : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'manager')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                
                                                  <div className="col-xl-4 col-md-4 col-xs-12">
                                                         <button
                                       type="button"
                                         className="btn btn-danger mt-2" 
                                         onClick={() => removeBox('manager')}
                                       >
                                         <i className="fa fa-remove"></i>
                                       </button>
                                                         </div> 
                                                    
                                                    
                                                        </div>
                                                      </FormGroup>    
                                                    </div> 
                                                    </>
                                                );
                                            }
                                            return arr1;
                                            
                                        })()}
                                                   
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                           
                                            <a className="btn btn-info mb-2"  onClick={() => addBox('other')}>+ Any other person   </a>
                                        <br></br>
                                                  {(() => {
                                            const arr1 = [];
                                            for (let k = 0; k < boxes.other; k++) {
                                                arr1.push(
                                                 <>
                                                    
                                                    <div className="col-md-12">
                                                       <FormGroup>
                                                       {/* <label>Level</label> */}
                                                       <div className="row">
                                                     
                                                  <div className="col-xl-3 col-md-3 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="name"
                                                            type="text"
                                                            name="name"
                                                            value={inputFields.other && inputFields.other[k] ? inputFields.other[k].name : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'other')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                                  <div className="col-xl-3 col-md-3 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="role"
                                                            type="text"
                                                            name="role"
                                                            value={inputFields.other && inputFields.other[k] ? inputFields.other[k].role : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'other')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                                  <div className="col-xl-3 col-md-3 col-xs-12">
                                                  <InputGroup className="input-group-alternative mb-3">
                                                          <Input
                                                            placeholder="email"
                                                            type="text"
                                                            name="email"
                                                            value={inputFields.other && inputFields.other[k] ? inputFields.other[k].email : ''}
                                                            onChange={(e) => inputclienthandler(e, k,'other')}
                                                            required
                                                          />
                                                        </InputGroup>     
                                                  </div>
                                
                                                  <div className="col-xl-3 col-md-3 col-xs-12">
                                                         <button
                                       type="button"
                                         className="btn btn-danger mt-2" 
                                         onClick={() => removeBox('other')}
                                       >
                                         <i className="fa fa-remove"></i>
                                       </button>
                                                         </div> 
                                                    
                                                    
                                                        </div>
                                                      </FormGroup>    
                                                    </div> 
                                                    </>
                                                );
                                            }
                                            return arr1;
                                            
                                        })()}
                                                   
                            </div>
                          </div>
                          <div className="row">         
                <div className="col-md-12">
                        <label>&nbsp;</label>
                          <Button className="col-2 " color="primary" type="submit" disabled={disablestate}>
                          {disablestate ? 'Sending...' : 'Update'} 
                         </Button>
                    </div>
                    
                </div>
                
                <FormGroup>
                  <InputGroup className="input-group-alternative mb-3"></InputGroup>
                </FormGroup>
                </Form>
              </Card>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Addfreqmaster;
